import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { breadcrumbSchema } from '../utils/structuredData';
export function TeamPage() {
  usePageSEO({
    canonical: '/team',
    keywords: 'Design Flow Digitals team, Shopify developers, ecommerce experts, Shopify agency team',
    jsonLd: breadcrumbSchema([{
      name: 'Home',
      path: '/'
    }, {
      name: 'Team',
      path: '/team'
    }]),
    title: 'Team | Design Flow Digitals',
    description: 'Meet the team behind Design Flow Digitals. Shopify developers, designers, and strategists dedicated to building premium ecommerce experiences.'
  });
  return <div className="pt-32 pb-20" data-id="element-1665" data-mp="1111ui0uh7bjz">
      <section className="px-6 md:px-12 max-w-5xl mx-auto text-center mb-24" data-id="element-1666" data-mp="111v3l8gwqd5a">
        <h1 className="text-5xl md:text-7xl font-bold mb-8" data-id="element-1667" data-mp="1xipski59qz05">Meet the Team</h1>
        <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-1668" data-mp="1xkssbtw846i2">
          Design Flow Digitals is powered by a team of designers, developers,
          and ecommerce specialists.
        </p>
      </section>

      <section className="section-padding bg-black border-y border-white/5" data-id="element-1669" data-mp="dcwbxaru611k">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1670" data-mp="df0g7ttnd22d">
          <h2 className="text-3xl font-bold mb-12" data-id="element-1671" data-mp="3usw3l4ue80em">Our Collective Expertise</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-1672" data-mp="3mkxuvefubgy">
            {['Shopify Development', 'UX/UI Design', 'Ecommerce Growth', 'Performance Engineering'].map((skill, i) => <div key={i} className="glass-card p-6 border-white/10" data-id="element-1673" data-mp="3qpppjb11h4xl" data-mpi={i}>
                <p className="font-medium text-white" data-id="element-1674" data-mp="3bwcqk4ggxscs">{skill}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="section-padding" data-id="element-1675" data-mp="1a3f18ilwhhwl">
        <div className="max-w-4xl mx-auto" data-id="element-1676" data-mp="1a4q5ejj9cro8">
          <h2 className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-12 text-center" data-id="element-1677" data-mp="1f2jblckk9loi">
            The People Behind the Work
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1678" data-mp="1dmxf5utxqcas">
            {/* Pankaj Maurya */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1679" data-mp="18kok8sxi5061">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-1680" data-mp="13ozrb8fzmhip">
                <img src="https://cdn.magicpatterns.com/uploads/mGfabHy4m1VsnCVj3nADJ1/Pankaj_Template_Profile_(1).png" alt="Pankaj Maurya" className="w-full h-full object-cover object-top" data-id="element-1681" data-mp="1wbkj2a0dkvms" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1682" data-mp="1mjo6xv1gf4zk">
                Pankaj Maurya
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1683" data-mp="2f2boj0h8s1vw">
                Founder · Fiverr Pro
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1684" data-mp="2abd4pqx1olnw">
                Founder of Design Flow Digitals and a Fiverr Pro professional.
                Full-stack developer with a Master's in Commerce, bringing deep
                ecommerce expertise and technical skill to every project. Over
                1,000 Shopify stores delivered for global brands and
                entrepreneurs.
              </p>
            </div>

            {/* Samuel Masih */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1685" data-mp="fruvxnhebz3b">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-1686" data-mp="kpwabv3vna8g">
                <img src="https://cdn.magicpatterns.com/uploads/9gTnZstt2EDzKocCdbCK3V/1718263422794.jpg" alt="Samuel Masih" className="w-full h-full object-cover object-top" data-id="element-1687" data-mp="pixscbzdrpw9" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1688" data-mp="13gw4rbu55c94">
                Samuel Masih
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1689" data-mp="ptx3xzidutbt">
                Lead Developer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1690" data-mp="kuualcbrmbjo">
                Full-stack Software Engineer specializing in the MERN stack,
                React, Next.js, and scalable web applications. Driven by
                curiosity and a deep analytical mindset, Samuel delivers
                end-to-end solutions from clean UI design to robust backend
                systems.
              </p>
            </div>

            {/* Saloni Gupta */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1691" data-mp="gtqs0i2c21er">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1692" data-mp="bu4h4f9z8x94">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1693" data-mp="1n91bm4oxkenv" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1694" data-mp="1uvoiosv5nye1">SG</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1695" data-mp="1zqlsw3468dsi">
                Saloni Gupta
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1696" data-mp="1lv9unlqt456u">
                Performance Engineer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1697" data-mp="2djl80401k5zj">
                Combines performance engineering with UX/UI design expertise to
                craft fast, beautiful ecommerce experiences that convert
                visitors into customers.
              </p>
            </div>

            {/* Neeraj Kushwaha */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1698" data-mp="28rtpmgr1h6kh">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1699" data-mp="2wh4izd627yol">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1700" data-mp="3b3bn0klh41o4" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1701" data-mp="3246p9ghqkcd0">NK</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1702" data-mp="2x6emtsjgt7uk">
                Neeraj Kushwaha
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1703" data-mp="2s7tvyjq3s0is">
                Marketing Lead
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1704" data-mp="2neiocgdgvfpt">
                Leads marketing strategy and brand growth, turning standout
                Shopify work into measurable demand and helping the right
                merchants discover Design Flow Digitals.
              </p>
            </div>

            {/* Upasana Choubey */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1705" data-mp="24hhfulkpexh4">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1706" data-mp="1uc95ylt9zqp5">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1707" data-mp="24ci62aqe1w9t" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1708" data-mp="298gzwduhk6hm">UC</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1709" data-mp="1bomaj9ck2aem">
                Upasana Choubey
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1710" data-mp="1gjjgg7ejg3na">
                Social Media Manager
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1711" data-mp="1qc7dn39fk9mj">
                Builds the social presence that keeps the agency top of mind,
                crafting content and campaigns that showcase client wins and
                grow an engaged community.
              </p>
            </div>

            {/* Akash Tomar */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1712" data-mp="2c2mkmq0mdqg5">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1713" data-mp="282cgliwe1a3x">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1714" data-mp="2h30umdls7agt" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1715" data-mp="2qzneaz2dfvh9">AT</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1716" data-mp="34r1vd0cpxmlo">Akash Tomar</h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1717" data-mp="2zrfhqpsza4cc">
                Full Stack Developer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1718" data-mp="3eo6hj06kdi2h">
                Builds robust Shopify storefronts and custom app features from
                front to back, delivering clean, scalable code that keeps stores
                fast and reliable.
              </p>
            </div>

            {/* Abhishek Yadav */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-1719" data-mp="172prcbx7cme">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1720" data-mp="3jflduayolhti">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1721" data-mp="39ll39tkmrkde" />
                <span className="text-3xl font-bold text-white/20" data-id="element-1722" data-mp="30niv8u2hbrgm">AY</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1723" data-mp="35lauk95gefuu">
                Abhishek Yadav
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1724" data-mp="2qpl9qec088rp">
                Graphics Designer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1725" data-mp="2vn4u7vzaphs3">
                Shapes the visual identity of every project, designing the
                graphics, store visuals, and brand assets that give each
                ecommerce experience a premium, polished look.
              </p>
            </div>

            {/* Join Us */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300 flex flex-col items-center justify-center" data-id="element-1726" data-mp="1wnqbmtp137sc">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-dashed border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-1727" data-mp="2kfnlwgctxrrc">
                <span className="text-3xl text-[#D4AF37]/40" data-id="element-1728" data-mp="2alwzri46dtet">+</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-1729" data-mp="2fkri6iy8dfye">
                Join Our Team
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-1730" data-mp="38357fu5i3tlv">
                We're Hiring
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1731" data-mp="wnmutkak3ejp">
                We're always looking for talented developers and designers
                passionate about ecommerce.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}